var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExplosiveGases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/hazard/explosive-gases") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/hazard/explosive-gases",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6012814,36.2887638 L32.7426785,36.4214727 L40.7202397,44.4135968 C43.5894492,41.5543597 48.193768,41.497777 51.1302369,44.2397586 L51.3234933,44.4267034 L85.8070039,79.004873 C88.6719396,81.8740825 88.7286461,86.4811886 85.9839404,89.4191421 L85.7968099,89.6124954 L78.9333112,96.4614312 C76.0655263,99.3235176 71.4584511,99.3815559 68.5204984,96.6382728 L68.327145,96.4512372 L33.8436344,61.8716113 C30.9829726,59.0066757 30.9235717,54.4010561 33.6640681,51.4618019 L33.8509158,51.2683577 L25.8748109,43.2747774 C24.771758,42.1703264 24.728978,40.4055535 25.7490478,39.2482768 L25.8820924,39.106873 L28.5747741,36.4171038 C29.6806231,35.3140509 31.4441098,35.2712709 32.6012814,36.2887638 Z M37.4807207,3.12207209 L42.178715,24.5994493 L48.618433,19.1776785 L49.1514355,28.5605604 L70.4671644,16.7005278 L59.5828467,32.4372066 L65.7167437,31.8517777 L59.8668234,42.258432 L56.820263,40.545834 L59.3935289,35.9672556 L52.4324587,36.6313242 L59.0614946,27.0445616 L45.9767215,34.3260158 L45.523815,26.3513672 L40.0001039,31.0013038 L37.2302387,18.3359424 L33.8560128,31.6522658 L21.8721956,18.6199192 L24.1964357,33.5716571 L16.8436233,31.8357585 L17.6606025,34.9726089 L14.2776389,35.8536649 L12,27.101357 L19.9440665,28.9770596 L16.6499366,7.77783389 L32.0545811,24.5295474 L37.4807207,3.12207209 Z M52.8868215,4.66850733 C57.5047197,6.05926507 61.5109758,9.328638 63.6895869,13.9829435 L53.3222524,17.9644426 L52.8868215,4.66850733 Z M31.2361456,2 L29.305104,10.7741523 L22.9105309,6.84799219 C24.9333189,4.02570055 28.0002674,2.35242238 31.2361456,2 Z",
    id: "explosive-gases",
    fill: "#1C7B97"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosiveGases);
export default __webpack_public_path__ + "static/media/explosive-gases.7d0be1c7.svg";
export { ForwardRef as ReactComponent };